import Vue from 'vue'
import global from '@/config/global'
import OSS from 'ali-oss'

export default async (file) => new Promise(async (resolve, reject) => {
    try {
        console.log('图片上传---->', global.baseApi);
        console.log('图片上传---->', file);

        // 判断尺寸 
        const MAX_SIZE = 400 * 1024; // 400KB
        if (file.size > MAX_SIZE) {
            // 拦截超大图片，提示用户
            const sizeKB = Math.round(file.size / 1024);
            reject({
                message: `图片文件尺寸为 ${sizeKB}KB，超过 400KB 限制，请压缩后再上传`,
                status: 10001
            });
            return;
        }

        if (file.size <= 400000) {
            // 创建 OSS 客户端，直接使用阿里云 AccessKey
            const client = new OSS({
                region: 'oss-cn-shanghai',  // 重点！只填地域标识，不要域名
                accessKeyId: 'LTAIWx7f5IUzNQk9',   //LTAI5tKqitnpyYbSWx62RQrn
                accessKeySecret: 'GHHfQjnHeKphLQ8aX2YJujFnaWOzGQ', //T3J0JifWumTP75CpdlZWOKbxaOG8ZX
                bucket: 'kdz-2023-photo-001',
                secure: true, // 强制使用 HTTPS
                cname: false
            });

            // 生成文件路径和文件名
            const now = new Date();
            const year = now.getFullYear();
            const month = String(now.getMonth() + 1).padStart(2, '0');
            const day = String(now.getDate()).padStart(2, '0');
            const timestamp = now.getTime();
            const fileName = `${year}${month}${day}/${timestamp}-${file.name}`;

            // 上传文件到 OSS
            const result = await client.put(`upload/${fileName}`, file);

            if (result.res.status === 200) {
                // 构建文件 URL
                const fileUrl = `https://kdz-2023-photo-001.oss-cn-shanghai.aliyuncs.com/upload/${fileName}`;
                console.log('阿里云 OSS 上传成功---->', fileUrl);
                resolve(fileUrl);
            } else {
                reject(new Error('阿里云 OSS 上传失败'));
            }
        }
    } catch (error) {
        console.error('阿里云 OSS 上传错误---->', error);
        reject(error);
    }
})
